<template>
  <IntegrationWorkflowWrapper
    :is-enabled="trayState?.accountPush === 'ALL'"
    :title="title"
    :description="description"
    :status="getStatusByWorkflowName(workflowName)"
    data-testid="account-object-workflow"
    v-slot="{ isSlotDisabled }"
    @update:is-enabled="(val) => (trayState.accountPush = val ? 'ALL' : 'NONE')"
  >
    <AccountObjectFields
      v-if="trayState.profileType === 'salesforce'"
      :disabled="isSlotDisabled"
    />
  </IntegrationWorkflowWrapper>
</template>

<script setup lang="ts">
import { computed, inject, onBeforeMount } from 'vue';

import { ProvidedTrayState } from '@/injectionKeys/integration_profiles';
import { usePartnerCloudStore } from '@/stores';
import { WorkflowsWithStatus } from '@/types/integrations';

import AccountObjectFields from './AccountObjectFields.vue';
import IntegrationWorkflowWrapper from './IntegrationWorkflowWrapper.vue';

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const trayState = inject(ProvidedTrayState)!;

const partnerCloudStore = usePartnerCloudStore();
const { getStatusByWorkflowName } = partnerCloudStore;
onBeforeMount(async () => {
  await partnerCloudStore.readySync;
});

const workflowName = computed<WorkflowsWithStatus | null>(() => {
  switch (trayState.profileType) {
    case 'salesforce':
      return 'SCH.Ecosystem fields to CSV [SFDC Ecosystem]';
    case 'hubspot':
      return 'Sch. HubSpot Ecosystem Fields Push';
    default:
      return null;
  }
});

const description = computed(
  () =>
    `Push partner overlap data into ${trayState.friendlyName}’s standard ${trayState.profileType === 'salesforce' ? 'Account' : 'Company'} object. This makes it available across the workflows, reports, dashboards, and processes your revenue team already uses every day.`,
);

const title = computed(() => `Push to ${trayState.friendlyName} Object`);
</script>
